import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function SearchCapsule({
  searchQuery,
  setSearchQuery,
  searchResults,
  onLinkClick,
  searchContainerRef,
  textColor = "text-gray-900"
}) {
  const isResultsOpen = searchResults.length > 0;
  const [isExpanded, setIsExpanded] = useState(false);

  // Custom function to handle navigation and cleanup
  const handleSelectLink = (href) => {
    setSearchQuery(""); // Clear search query
    setIsExpanded(false);
    if (onLinkClick) onLinkClick();      // Execute cleanup/close handler
  };

  const handleContainerLeave = () => {
    if (!searchQuery && !isResultsOpen) {
      setIsExpanded(false);
    }
  };

  return (
    <div
      className="relative flex items-center justify-end h-10 w-10 navMD:w-auto"
      ref={searchContainerRef}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={handleContainerLeave}
    >
      <div
        className={`flex items-center transition-all duration-300 ease-in-out overflow-hidden ${isExpanded
            ? "absolute top-full left-0 mt-4 w-[240px] h-12 rounded-xl shadow-lg bg-gray-100 border border-gray-300 opacity-100 z-[60] navMD:relative navMD:top-auto navMD:left-auto navMD:mt-0 navMD:h-full navMD:w-64 navMD:rounded-none navMD:shadow-none"
            : "absolute top-0 left-0 w-10 h-full bg-transparent border-transparent opacity-0 pointer-events-none navMD:relative navMD:top-auto navMD:left-auto"
          }`}
      >
        <input
          type="text"
          placeholder="جستجو..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className={`w-full h-full pr-10 pl-4 bg-transparent text-[16px] text-right focus:outline-none focus:ring-0 ${isExpanded ? "block" : "hidden"}`}
          dir="rtl"
        />
      </div>

      {/* Icon is placed absolutely over the right side of the container */}
      <button
        className="absolute right-0 w-10 h-10 flex items-center justify-center z-10"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label="Search"
      >
        <Image
          src="/search.svg"
          alt="Search"
          width={19.5}
          height={19.5}
          className={textColor.includes("white") ? "brightness-0 invert" : "brightness-0"}
        />
      </button>

      {/* Search Results Dropdown */}
      {isResultsOpen && isExpanded && (
        <div className="absolute top-full left-0 mt-20 w-[240px] navMD:mt-2 navMD:w-64 bg-white shadow-xl rounded-lg border border-gray-200 z-[70] max-h-80 overflow-y-auto">
          {searchResults.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              onClick={() => handleSelectLink(link.href)}
              className="flex flex-col p-3 hover:bg-blue-50 transition-colors border-b border-gray-100 text-right"
              dir="rtl"
            >
              <span className="text-sm font-semibold text-[#313E75]">
                {link.label}
              </span>
              {link.parentLabel && (
                <span className="text-xs text-gray-500 mt-0.5">
                  {'< '} {link.parentLabel}
                </span>
              )}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}